import { compose } from 'recompose';

import PageTitleView from './PageTitleView';

export default compose()(PageTitleView);
